<template>
    <div class="content">
        <img class="img_home" src="@/assets/backhome.png" @click.prevent.stop="goBackHome($event)"/>
        <div>
            <iframe :src="url" class="frame" allowfullscreen></iframe>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            url: ''
        }
    },
    methods: {
        goBackHome(event) {
            console.log("goBackHome");
            this.$router.back()
        }
    },
    mounted() {
        // this.$refs.cascader._data.dropDownVisible = true
        this.url = this.$route.query.index;
        // console.log(this.$refs.cascader._data.dropDownVisible)
    }
}
</script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
    height: 100vh;
    width: 100vh;
}
.img_home {
    position: absolute;
    z-index: 1000;
    top: 24px;
    right: 29px;
    height: 20px;
    width: 20px;
    cursor: pointer;
}

@media screen and (max-width: 750px) {
    .img_home {
        z-index: 1000;
        top: 34px;
        right: 29px;
        height: 38px;
        width: 38px;
        cursor: pointer;
    }
}

.frame {
    width: 100vw;
    height: 100vh;
    border: 1px solid #fff;
    background-color: #fff;
}
</style>
  